import { render, staticRenderFns } from "./manualBillGenerationDetail.vue?vue&type=template&id=93ba4fec"
import script from "./manualBillGenerationDetail.vue?vue&type=script&lang=js"
export * from "./manualBillGenerationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports